export default function createResourceMiddleware(resources = {}) {
  return ({ dispatch, getState }) => next => action => {
    const getResource = resources[action.resource];
    if (getResource && typeof action.payload === 'function') {
      const result = action.payload(dispatch, getState, getResource());

      // Pass through a simple action, useful for state tracking
      dispatch({ type: action.type });

      return new Promise(async (resolve, reject) => {
        try {
          resolve(await result);
        } catch (e) {
          reject(e);
        }
      });
    } else if (action.resource) {
      // NOTE: do we need payload here?
      const { payload, ...newAction } = action; // eslint-disable-line no-unused-vars
      newAction.meta = 'Resource not available';
      return next(newAction);
    }

    return next(action);
  };
}



// WEBPACK FOOTER //
// ./src/state/middleware/resourceMiddleware.js